<template>
  <footer class="footer">
    <div class="container footer-inner">
      <div class="footer-top">
        <div class="footer-brand">
          <div class="footer-mark">余</div>
          <div>
            <div class="footer-name">余静 · 细雨若静</div>
            <div class="footer-desc"><i class="fa-brands fa-android footer-desc-icon"></i> Android 开发工程师 · <i class="fa-solid fa-code-branch footer-desc-icon"></i> 开源创作者</div>
          </div>
        </div>
        <div class="footer-social">
          <a v-for="c in socials" :key="c.label" :href="c.url" target="_blank" rel="noopener" :title="c.label" class="social-link">
            <i :class="c.icon"></i>
          </a>
        </div>
      </div>

      <div class="footer-divider"></div>

      <div class="footer-bottom">
        <p>{{ site.copyright }}</p>
        <p class="beian">
          <a :href="beian.wangAn.url" target="_blank" rel="noopener">
            <img src="https://beian.mps.gov.cn/img/logo01.dd7ff50e.png" alt="公安备案" class="beian-icon" />
            {{ beian.wangAn.name }}
          </a>
          <span class="dot">·</span>
          <a :href="beian.ICP.url" target="_blank" rel="noopener">{{ beian.ICP.name }}</a>
        </p>
      </div>
    </div>
  </footer>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { site } from '@/data/site.js'

const beian = ref({ wangAn: {}, ICP: {} })

const socials = [
  { label: 'GitHub', icon: 'fa-brands fa-github', url: site.github },
  { label: 'Gitee', icon: 'fa-brands fa-git-alt', url: site.gitee },
  { label: 'CSDN', icon: 'fa-brands fa-blogger-b', url: site.csdn },
  { label: '微博', icon: 'fa-brands fa-weibo', url: site.weibo },
  { label: 'QQ', icon: 'fa-brands fa-qq', url: site.qqLink },
  { label: '邮箱', icon: 'fa-solid fa-envelope', url: `mailto:${site.email}` }
]

onMounted(() => {
  beian.value = site.getBeian()
})
</script>

<style scoped>
.footer {
  background: var(--bg-surface);
  border-top: 1px solid var(--border-soft);
  padding: 56px 0 32px;
  margin-top: 40px;
}
.footer-inner { max-width: var(--container); margin: 0 auto; padding: 0 32px; }
.footer-top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 24px;
  flex-wrap: wrap;
}
.footer-brand { display: flex; align-items: center; gap: 14px; }
.footer-mark {
  width: 44px; height: 44px;
  display: grid; place-items: center;
  background: var(--accent); color: var(--bg-base);
  font-family: var(--font-display); font-weight: 700; font-size: 1.2rem;
  border-radius: 10px;
  box-shadow: 0 4px 20px rgba(56, 189, 248, 0.3);
  animation: footer-pulse 3s ease-in-out infinite;
}
@keyframes footer-pulse {
  0%, 100% { box-shadow: 0 4px 20px rgba(56, 189, 248, 0.3); }
  50% { box-shadow: 0 4px 30px rgba(56, 189, 248, 0.5); }
}
.footer-desc-icon {
  color: var(--accent);
  margin-right: 2px;
  font-size: 0.8rem;
}
.footer-name { font-family: var(--font-display); font-weight: 600; font-size: 1.05rem; }
.footer-desc { color: var(--text-muted); font-size: 0.85rem; margin-top: 2px; }

.footer-social { display: flex; gap: 10px; }
.social-link {
  width: 40px; height: 40px;
  display: grid; place-items: center;
  border: 1px solid var(--border);
  border-radius: 10px;
  color: var(--text-muted);
  font-size: 1.05rem;
  transition: all 0.3s ease;
}
.social-link:hover {
  color: var(--accent);
  border-color: var(--accent);
  transform: translateY(-3px) rotate(-6deg);
  background: var(--accent-soft);
  box-shadow: 0 8px 20px rgba(56, 189, 248, 0.2);
}

.footer-divider {
  height: 1px;
  background: var(--border-soft);
  margin: 32px 0 24px;
}
.footer-bottom {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
  color: var(--text-dim);
  font-size: 0.82rem;
}
.beian { display: flex; align-items: center; gap: 8px; flex-wrap: wrap; }
.beian a { display: inline-flex; align-items: center; gap: 6px; color: var(--text-dim); }
.beian a:hover { color: var(--text-muted); }
.beian-icon { width: 16px; height: 16px; }
.dot { color: var(--text-dim); }

@media (max-width: 640px) {
  .footer-top { flex-direction: column; align-items: flex-start; }
  .footer-bottom { flex-direction: column; align-items: flex-start; }
}
</style>
